var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApplicationContext } from "../../../ApplicationContext";
import React, { createRef } from "react";
import { injectIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import { observer } from "mobx-react";
import BasicFormGroup from "../../components/ui/BasicFormGroup/BasicFormGroup";
import { getEnumKeys } from "../../../utils/enumUtils";
import { TimezoneType } from "../../../data/TimezoneType";
var ReportTimezone = /** @class */ (function (_super) {
    __extends(ReportTimezone, _super);
    /**
     *
     */
    function ReportTimezone(props) {
        var _this = _super.call(this, props) || this;
        _this.selectRef = createRef();
        _this.state = {};
        return _this;
    }
    ReportTimezone.prototype.componentDidMount = function () {
        this.updateReportParameter();
    };
    ReportTimezone.prototype.render = function () {
        var _a = this.props, intl = _a.intl, reportParameterInfoModel = _a.reportParameterInfoModel;
        return React.createElement(Row, null,
            React.createElement(Col, { sm: 12 },
                React.createElement(BasicFormGroup, { htmlFor: reportParameterInfoModel.parameterId, label: intl.formatMessage({ id: 'reports.settings.form.timezone.unit' }) },
                    React.createElement("select", { id: reportParameterInfoModel.parameterId, ref: this.selectRef, name: reportParameterInfoModel.parameterId, className: "form-control w-100", onChange: this.onInputChange }, getEnumKeys(TimezoneType).map(function (key, index) { return React.createElement("option", { key: 'opt-' + key + '-' + index, value: key }, key); })))));
    };
    ReportTimezone.prototype.onInputChange = function (event) {
        if (event.target.name === 'amount') {
            this.setState({ amount: event.target.value });
        }
        this.updateReportParameter();
    };
    ReportTimezone.prototype.updateReportParameter = function () {
        var reportParameterModel = this.props.reportParameterModel;
        reportParameterModel.value = this.selectRef.current.value;
    };
    ReportTimezone = __decorate([
        observer
    ], ReportTimezone);
    return ReportTimezone;
}(React.Component));
ReportTimezone.contextType = ApplicationContext;
export default injectIntl(ReportTimezone);
